module.exports = __webpack_public_path__ + "img/avti_3.59cf9c01.png";